export function dashboardWidgetTableBodyMaxHeight({
  renderedRowCount,
  rowHeightPx,
  scrollportHeightPx,
  sectionHeaderHeightPx,
  columnHeaderHeightPx,
  paginationFooterHeightPx,
  sectionGapPx,
}: {
  renderedRowCount: number;
  rowHeightPx: number;
  scrollportHeightPx: number;
  sectionHeaderHeightPx: number;
  columnHeaderHeightPx: number;
  paginationFooterHeightPx: number;
  sectionGapPx: number;
}): number | undefined {
  if (renderedRowCount <= 0 || rowHeightPx <= 0) {
    return undefined;
  }

  const availableHeightPx = Math.max(
    0,
    scrollportHeightPx -
      sectionHeaderHeightPx -
      columnHeaderHeightPx -
      paginationFooterHeightPx -
      sectionGapPx,
  );

  if (availableHeightPx <= 0) {
    return undefined;
  }

  const desiredHeightPx = renderedRowCount * rowHeightPx;
  const cappedHeightPx = Math.max(rowHeightPx, availableHeightPx - rowHeightPx);
  return Math.min(desiredHeightPx, cappedHeightPx);
}

export function readDashboardWidgetTableBodyMaxHeight(
  section: HTMLElement,
  renderedRowCount: number,
): number | undefined {
  // The widget title, search and actions sit in the table card's header.
  const sectionHeader = section.querySelector('[data-slot="dashboard-table-card-header"]');
  const table = section.querySelector('table');
  const row = table?.tBodies.item(0)?.rows.item(0);
  const nestedTableSection = section.querySelector(':scope > section');
  const footer = section.querySelector('[data-dashboard-table-footer]');
  const gapPx = nestedTableSection
    ? Number.parseFloat(getComputedStyle(nestedTableSection).marginTop)
    : 0;
  const scrollport = findDashboardWidgetTableScrollport(section);

  return dashboardWidgetTableBodyMaxHeight({
    renderedRowCount,
    rowHeightPx: row?.getBoundingClientRect().height ?? 0,
    scrollportHeightPx: scrollport?.clientHeight ?? window.innerHeight,
    sectionHeaderHeightPx: sectionHeader instanceof HTMLElement ? sectionHeader.offsetHeight : 0,
    columnHeaderHeightPx: table?.tHead?.offsetHeight ?? 0,
    paginationFooterHeightPx: footer instanceof HTMLElement ? footer.offsetHeight : 0,
    sectionGapPx: Number.isFinite(gapPx) ? gapPx : 0,
  });
}

export function findDashboardWidgetTableScrollport(element: HTMLElement): HTMLElement | undefined {
  let current = element.parentElement;
  while (current) {
    const overflowY = getComputedStyle(current).overflowY;
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return current;
    }
    current = current.parentElement;
  }
  return undefined;
}
